import React from 'react';
import { ModalHeader } from '../../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalBody } from '../../../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../../../CommonComponents/OPL/Modal/Modal';

const HEADER_ID = 'dependent-to-delete-modal--header';

interface Props {
  onDeleteDependent(): void;
  onClose(): void;
}

export const DeleteDependentModal: React.FC<Props> = ({ onDeleteDependent, onClose }) => {
  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      aria={{ labelledby: HEADER_ID }}
    >
      <ModalHeader as="h2" id={HEADER_ID} variant="warning">
        Are you sure you want to delete this beneficiary?
      </ModalHeader>

      <ModalBody as="section">
        Deleting this beneficiary may remove associated goals (college fund, etc.).
      </ModalBody>

      <ModalFooter as="footer">
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button
          variant="error"
          onClick={() => {
            onDeleteDependent();
            onClose();
          }}
          ml="8"
        >
          Delete Beneficiary
        </Button>
      </ModalFooter>
    </Modal>
  );
};
